<template>
  <div class="twig-color-type">
    <t-input
      v-model="modelColor"
      :label="name"
      :placeholder="name"
      :inverse="inverse"
    ></t-input>
  </div>
</template>

<script>
import TInput from "../../TInput/TInput.vue";

export default {
  props: {
    name: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    inverse: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TInput,
  },
  computed: {
    modelColor: {
      get() {
        return this.color;
      },
      set(val) {
        this.$emit("inputColor", val);
      },
    },
  },
};
</script>

<style lang="scss">
.twig-color-type {
  display: flex;
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
